import React from "react";

import { useQuery } from "@apollo/client";

import { loader } from "graphql.macro";

import TrendGraphHighcharts from "./trend-graph-highcharts";
// import TrendGraphRecharts from './trend-graph-recharts';

import { allData as allDataFn } from "./trend-graph-utils";

const TrendMetaData = loader("../graphql/TrendMetaData.graphql");

const TrendValues = loader("../graphql/TrendValues.graphql");

interface Props {
  nodes?: any[];
  panelId?: string;
  startDate: number; // Date;
  endDate: number; // Date;
  widgetStatic?: boolean;
  widgetTitle?: string;
}

function TrendGraphContainer(props: Props) {
  // startDate={data.durationSelect && data.durationSelect.startDate || '2010-01-01T00:00:00.00Z'} endDate={data.durationSelect && data.durationSelect.endDate || '2020-01-01T00:00:00.00Z'}
  const {
    nodes,
    panelId,
    startDate,
    endDate,
    widgetStatic,
    widgetTitle,
  } = props;

  // if (panelId) {
  //  // Fetch DataViewPanelState with sensors and thresholds and event nodes
  // } else {
  //  // Create new DataViewPanelState (see TrendURLHandler)
  //  // for the (selected) nodes get tags (see TrendURLHandler#getTags)
  //  //
  // }
  //// Generate flot/highcharts metadata and (in parallel)
  //// Fetch values and transform to highcharts data => use highcharts methods? use dynamic loading?
  const n = nodes ? nodes.map((n) => n.id).join(",") : undefined;

  const { data, error: metaError, loading: metaLoading } = useQuery(
    TrendMetaData,
    {
      variables: { panel: panelId, nodes: n },
    }
  );
  const {
    data: dataSeries,
    error: valuesError,
    loading: valuesLoading,
  } = useQuery(TrendValues, {
    variables: { panelId, nodes: n, startDate, endDate },
  });
  if (metaLoading) {
    return <div>Loading...</div>;
  }
  if (metaError) {
    console.error(metaError.message);
    return <div>Error! {metaError.message}</div>;
  }
  if (valuesLoading) {
    return <div>Loading...</div>;
  }
  if (valuesError) {
    console.error(valuesError.message);
    return <div>Error! {valuesError.message}</div>;
  }

  const allData = allDataFn(data.metaData);
  // const chartData = mergeSeries(dataSeries.dataSeries);
  return (
    <TrendGraphHighcharts
      // nodes={nodes}
      allData={allData}
      metaData={data.metaData}
      // chartData={chartData}
      dataSeries={dataSeries ? dataSeries.dataSeries : undefined}
      widgetStatic={widgetStatic}
      widgetTitle={widgetTitle}
    />
  );
}

export default TrendGraphContainer;
